import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-parametrage-layout",
  templateUrl: "./parametrage-layout.component.html",
  styleUrls: ["./parametrage-layout.component.scss"],
})
export class ParametrageLayoutComponent implements OnInit {
  constructor(private spinner: NgxSpinnerService) {}

  ngOnInit() {
    // Safety: clear any leftover overlay from Control Panel modal saves
    this.spinner.hide();
  }
}
